export const triggerMCPEvent = (eventName: string) => {
  const customEvent = new CustomEvent(eventName)
  console.info(`AEM: Before MCP event: ${eventName} `)
  document?.querySelector('body')?.dispatchEvent(customEvent)
  console.info(`AEM: After MCP event: ${eventName} `)
}
